import {
  mdiAccount,
  mdiBasketMinusOutline,
  mdiBasketOffOutline,
  mdiBasketOutline,
  mdiBasketPlusOutline,
  mdiBriefcaseDownloadOutline,
  mdiBriefcaseMinusOutline,
  mdiBriefcaseOffOutline,
  mdiBriefcasePlusOutline,
  mdiCart,
  mdiCartMinus,
  mdiCartOff,
  mdiCartPlus,
  mdiCheckboxBlankCircleOutline,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiClipboardMinusOutline,
  mdiClipboardOffOutline,
  mdiClipboardOutline,
  mdiClipboardPlusOutline,
  mdiCloseCircleOutline,
  mdiCloudDownload,
  mdiCloudDownloadOutline,
  mdiDelete,
  mdiDeleteForever,
  mdiDeleteForeverOutline,
  mdiDeleteOff,
  mdiDeleteOffOutline,
  mdiDeleteOutline,
  mdiDownload,
  mdiDownloadOff,
  mdiDownloadOffOutline,
  mdiDownloadOutline,
  mdiExitToApp,
  mdiEye,
  mdiEyeOff,
  mdiEyeOffOutline,
  mdiEyeOutline,
  mdiFileAlertOutline,
  mdiFolder,
  mdiFormatListBulleted,
  mdiFormatListBulletedSquare,
  mdiHome,
  mdiHomeOutline,
  mdiInformationOutline,
  mdiLock,
  mdiMagnify,
  mdiMagnifyMinusOutline,
  mdiMagnifyPlusOutline,
  mdiMenu,
  mdiPlayCircleOutline,
  mdiPlusCircleOutline,
  mdiViewModule,
} from '@mdi/js'

export default {
  icons: {
  mdiAccount,
    mdiBasketMinusOutline,
    mdiBasketOffOutline,
    mdiBasketOutline,
    mdiBasketPlusOutline,
    mdiBriefcaseDownloadOutline,
    mdiBriefcaseMinusOutline,
    mdiBriefcaseOffOutline,
    mdiBriefcasePlusOutline,
    mdiCart,
    mdiCartMinus,
    mdiCartOff,
    mdiCartPlus,
    mdiCheckboxBlankCircleOutline,
    mdiChevronDown,
    mdiChevronLeft,
    mdiChevronRight,
    mdiChevronUp,
    mdiClipboardMinusOutline,
    mdiClipboardOffOutline,
    mdiClipboardOutline,
    mdiClipboardPlusOutline,
    mdiCloseCircleOutline,
    mdiCloudDownload,
    mdiCloudDownloadOutline,
    mdiDelete,
    mdiDeleteForever,
    mdiDeleteForeverOutline,
    mdiDeleteOff,
    mdiDeleteOffOutline,
    mdiDeleteOutline,
    mdiDownload,
    mdiDownloadOff,
    mdiDownloadOffOutline,
    mdiDownloadOutline,
    mdiExitToApp,
    mdiEye,
    mdiEyeOff,
    mdiEyeOffOutline,
    mdiEyeOutline,
    mdiFileAlertOutline,
    mdiFolder,
    mdiFormatListBulleted,
    mdiFormatListBulletedSquare,
    mdiHome,
    mdiHomeOutline,
    mdiInformationOutline,
    mdiLock,
    mdiMagnify,
    mdiMagnifyMinusOutline,
    mdiMagnifyPlusOutline,
    mdiMenu,
    mdiPlayCircleOutline,
    mdiPlusCircleOutline,
    mdiViewModule,
  }
}